import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import RecordBetsReportUsers from 'views/reports/betsReport/recordTableReport'; // Importing a specific view for user records
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing the record bets report view.
 * @extends JetView
 */
export default class recordBetsReportView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service for translations
        const theme = this.app.config.theme; // Current theme configuration

        // Toolbar configuration with pagination and selection options
        const toolbar = {
            view: 'toolbar',
            css: 'highlighted_header header6',
            paddingX: 5,
            paddingY: 5,
            height: 40,
            cols: [
                {
                    view: 'select', // Dropdown for selecting number of items per page
                    options: ['10', '20', '50', '100'],
                    width: 70,
                    on: {
                        onChange: function () {
                            // Event handler for changing the page size
                            $$('datatable').getPager().config.size = this.getValue() * 1; // Update pager size based on selection
                            $$('datatable').refresh(); // Refresh the datatable to apply changes
                        },
                    },
                },
                {
                    view: 'pager', // Pager component for navigation
                    id: 'pagerA',
                    template:
                        '{common.first()}{common.prev()}&nbsp; {common.pages()}&nbsp; {common.next()}{common.last()}',
                    autosize: false,
                    height: 35,
                    size: devConfig.getDefaultDataFetch(), // Default fetch size from configuration
                },
            ],
        };

        // Left side layout containing toolbar and user records
        const left = {
            rows: [
                {
                    view: 'toolbar', // Toolbar for displaying ticket details
                    css: theme,
                    elements: [
                        { view: 'label', label: _('Detalles del Ticket') }, // Label for ticket details
                    ],
                },
                RecordBetsReportUsers, // Including the user records view
                toolbar, // Adding the toolbar to the layout
            ],
        };

        // Main layout configuration
        return {
            id: 'gridb',
            height: screen.width < 820 ? 430 : 0, // Responsive height based on screen width
            type: 'wide',
            cols: [left], // Main column layout
        };
    }
}

// FILE DOCUMENTED
